import { Component, h, Element, State, Prop, Watch, Host } from "@stencil/core"
import {
  AccordionState,
  AccordionActions,
  accordionReducer,
  getInitialState,
} from "../accordion-store"
import {
  StoreConnection,
  StateHandle,
  getAppearance,
} from "../../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-accordion-item",
  styleUrl: "accordion-item.scss",
  shadow: true,
})
export class AccordionItem {
  private store: StoreConnection<this, AccordionState, AccordionActions>
  private isReappending = false

  @Element() public el!: HTMLSdxAccordionItemElement

  @State() public state!: StateHandle<AccordionState>

  /**
   * Opens/closes the accordion item. Is not updated by user interaction.
   */
  @Prop() public open: boolean = false

  @Watch("open")
  public openChanged() {
    this.open
      ? this.store.dispatch({
          type: "OPEN_ACCORDION_ITEM_EL",
          accordionItemEl: this.el,
        })
      : this.store.dispatch({
          type: "CLOSE_ACCORDION_ITEM_EL",
          accordionItemEl: this.el,
        })
  }

  constructor() {
    this.store = new StoreConnection(
      this,
      accordionReducer,
      getInitialState(),
      ["openAccordionItemEls", "arrowPosition"],
    )
  }

  public connectedCallback() {
    if (this.isReappending) {
      this.isReappending = false
      return
    }

    // Register self
    this.store.dispatch({
      type: "ADD_ACCORDION_ITEM_EL",
      accordionItemEl: this.el,
    })

    if (this.open) {
      this.store.dispatch({
        type: "OPEN_ACCORDION_ITEM_EL",
        accordionItemEl: this.el,
      })
    }
  }

  public disconnectedCallback() {
    if (this.el.isConnected) {
      this.isReappending = true
      return
    }

    // Unregister self
    this.store.dispatch({
      type: "REMOVE_ACCORDION_ITEM_EL",
      accordionItemEl: this.el,
    })

    if (this.open) {
      this.store.dispatch({
        type: "CLOSE_ACCORDION_ITEM_EL",
        accordionItemEl: this.el,
      })
    }
  }

  public componentDidLoad() {
    this.store.subscribe()
  }

  private getHostClassNames() {
    const { arrowPosition } = this.state.get()

    return {
      [getAppearance(this.el)]: true,
      [arrowPosition]: true,
    }
  }

  public render() {
    return (
      <Host class={this.getHostClassNames()}>
        <div class="component">
          <slot />
        </div>
      </Host>
    )
  }
}
